module.exports = __webpack_public_path__ + "static/media/intro-video.018e61db.mp4";


//////////////////
// WEBPACK FOOTER
// ./public/img/Landing/intro-video.mp4
// module id = 1126
// module chunks = 0